import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react-lite'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import { ArrowBackOutlined } from '@mui/icons-material'
import Box from '@mui/material/Box'
import { themeConfig } from '@gap/shared/theme'
import { useGapDialogStore } from './GapDialogStore'

export default observer(function GapDialogTitle() {
   const gapDialogStore = useGapDialogStore()

   const BackButton = <Button startIcon={<ArrowBackOutlined />} size="small" sx={{ width: '100px', mt: 2, ml: -2 }} onClick={gapDialogStore.resetChildContent}>Back</Button>

   if (!gapDialogStore.sp.title) {
      return null
   }

   const divider = gapDialogStore.showDivider ? { borderBottom: `1px solid ${themeConfig.primary[200]}` } : {}

   if (gapDialogStore.showClose) {
      return <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: gapDialogStore.childContent ? 0 : 2, ...divider }}>
         <Box>
            {gapDialogStore.childContent ? BackButton : null}
            <Typography variant="h6" color="primary" sx={{ display: 'flex', flexGrow: 1 }} id="message-dialog-title">{gapDialogStore.title}</Typography>
            <Subtitle />
         </Box>
         <Box>
            <IconButton onClick={gapDialogStore.handleDirectClose} sx={{ ...!!gapDialogStore.childContent ? { mt: 1 } : {} }} data-button={'close-modal-button'}>
               <CloseIcon />
            </IconButton>
         </Box>
      </Toolbar>
   }

   return <Toolbar sx={{ ...divider }}>
      {gapDialogStore.childContent ? BackButton : null}
      <Typography variant="h6" id="message-dialog-title">{gapDialogStore.title}</Typography>
      <Subtitle />
   </Toolbar>
})

const Subtitle = observer(function Subtitle() {
   const gapDialogStore = useGapDialogStore()

   if (!gapDialogStore.subTitle) {
      return null
   }

   if (typeof gapDialogStore.subTitle === 'string') {
      return <Typography variant="body2" color={themeConfig.primary[600]} id="message-dialog-subtitle" sx={{ mb: 1 }}>{gapDialogStore.subTitle}</Typography>
   }

   return gapDialogStore.subTitle
})
